module.exports = __webpack_public_path__ + "static/media/marketplace-cart-logo.5d3322a0.png";